export default function dedupeRows(rows, key) {
  const seen = new Set();
  return (Array.isArray(rows) ? rows : []).filter(row => {
    const id = row?.[key];
    if (seen.has(id)) {
      return false;
    }
    seen.add(id);
    return true;
  });
}
